import React,{useState} from 'react'
import { TextField, Grid } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import RegisteredTable from './Components/RegisteredAccountsTable';



const RegisteredAccounts = () => {
    const [Status, setStatus] = React.useState('');
    const [active,setActive]=useState(null)

    const handleChange = (event) => {
        setStatus(event.target.value);
    };

    const handleCurrent=(value)=>{
        setActive(value)
    }

    return (
        <Grid container gap={2}>
            <Grid item xl={12} mb={2}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        '& > *': {
                            m: 1,
                        },
                    }}
                >
                    <ButtonGroup variant="outlined" size='small'   aria-label="Basic button group">
                        <Button variant={active==='online'?'contained':'outlined'} onClick={()=>handleCurrent('online')}>Online</Button>
                        <Button variant={active==='cash'?'contained':'outlined'} onClick={()=>handleCurrent('cash')}>Cash Deposit</Button>
                        <Button variant={active==='upi'?'contained':'outlined'} onClick={()=>handleCurrent('upi')}>UPI (Unique Payment Interface)</Button>
                        <Button variant={active==='van'?'contained':'outlined'} onClick={()=>handleCurrent('van')}>VAN (Virtual Account Number)</Button>
                    </ButtonGroup>
                    
                </Box>
            </Grid>
            <Grid item xl={3}>
                <TextField
                    id="outlined-basic"
                    label="Account Number"
                    variant="outlined"
                    fullWidth
                />
            </Grid>
            <Grid item xl={3}>
                <TextField
                    id="outlined-basic"
                    type='Date'
                    variant="outlined"
                    fullWidth
                />
            </Grid>
            <Grid item xl={3} md={3} sm={12} xs={12}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Status</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={Status}
                        label="Status"
                        onChange={handleChange}
                        fullWidth
                    >
                        <MenuItem value={'Active'}>Active</MenuItem>
                        <MenuItem value={'Inactive'}>Inactive</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xl={12}  sx={{justifyContent:'end',alignItems:'flex-end',width:'100%'}}>
                <Button  variant="contained" color="primary" sx={{width:'5rem'}}>
                    Search
                </Button>
            </Grid>
            <Grid item xl={12} mt={2}>
                <RegisteredTable/>
            </Grid>
        </Grid>
    )
}

export default RegisteredAccounts
